import { Enum, ResponseError } from '@/common/utils';

export type RedeemVoucherParams = {
  voucherId: string;
};

type Channel = 'Web' | 'Mobile';
type PurchaseMechanism = 'Voucher' | 'Payment';
type Source = 'OSMaps' | 'Mapshop' | 'iOS' | 'Android' | 'BigCommerce';

type OneTimeProduct = {
  channel: Channel;
  dateOfPurchase: string;
  orderId: string;
  productGroup: string;
  productId: string;
  purchaseMechanism: PurchaseMechanism;
  purchaseMechanismId: string;
  purchaseReferenceId: string;
  source: Source;
  subChannel: Source;
};

type SmartMap = {
  bbox: number[];
  centre: number[];
  channel: Channel;
  dateOfPurchase: string;
  isbn: string;
  mapCode: string;
  orderId: string;
  productGroup: string;
  productId: string;
  publishDate: string;
  purchaseMechanism: PurchaseMechanism;
  purchaseReferenceId: string;
  source: Source;
  subChannel: Source;
  title: string;
  transactionId: string;
  voucherCode: string;
};

type Subscription = {
  cancellationDate: string;
  channel: Channel;
  dateOfPurchase: string;
  effectiveEndDate: string;
  endDate: string;
  orderId: string;
  productGroup: string;
  productId: string;
  purchaseMechanism: PurchaseMechanism;
  startDate: string;
  subChannel: Source;
};

export type RedeemVoucherResponse =
  | ResponseError
  | {
      oneTimeProduct: OneTimeProduct;
      smartMap: SmartMap;
      subscription: Subscription;
    };

export type RedeemVoucherResponseStatus = Enum<typeof RedeemVoucherResponseStatus>;
export const RedeemVoucherResponseStatus = Enum('SUCCESS', 'NOT_RECOGNISED', 'HAS_ALREADY_BEEN_REDEEMED');

export type RedeemVoucherResponseEntity = {
  data: RedeemVoucherResponse;
  status: RedeemVoucherResponseStatus;
};
